import * as forge from 'node-forge';
import { IVote } from '../api-client/models/vote';
import { ArgumentValidator } from './argument-validator';

export interface IEncryptedValue {

    iv: string;

    key: string;

    cipher: string;
}

export class VoteEncryption {

    public encrypt(publicKeyPem: string, votes: IVote): IEncryptedValue {

        ArgumentValidator.notNullOrEmpty(publicKeyPem, `publicKeyPem`);
        ArgumentValidator.notNullOrEmpty(votes, `votes`);

        const publicKey = forge.pki.publicKeyFromPem(publicKeyPem) as forge.pki.rsa.PublicKey;

        const aesKey = forge.random.getBytesSync(16);

        const aesIv = forge.random.getBytesSync(16);

        const aesKeyHex = forge.util.bytesToHex(aesKey);

        const aesIvHex = forge.util.bytesToHex(aesIv);

        const aesKeyHexEncrypted64 = btoa(publicKey.encrypt(aesKeyHex));

        const aesIvHexEncrypted64 = btoa(publicKey.encrypt(aesIvHex));

        const aesCipher = forge.cipher.createCipher('AES-CBC', aesKey);

        const voteJson = JSON.stringify(votes);

        aesCipher.start({ iv: aesIv });

        aesCipher.update(forge.util.createBuffer(voteJson));

        aesCipher.finish();

        const aesCipherHex = aesCipher.output.toHex();

        const aesEncrypted64 = btoa(aesCipherHex);

        return {
            iv: aesIvHexEncrypted64,
            key: aesKeyHexEncrypted64,
            cipher: aesEncrypted64
        };
    }

}
